<template>
    <div class="compare">
        <div class="container">
            <br><br>
            <form @submit.prevent="doSearch()">
                <input type="text" v-model="licenseplate" placeholder="Tilføj bil" />
                <button type="submit">Tilføj</button>
            </form>
            <br><br>
            <div class="compare-wrapper" v-if="vehicles.length > 0">
                <div class="line">
                    <div class="line__meta">
                        
                    </div>
                    <div class="line__value" v-for="(vehicle, index) in vehicles">
                        <a href="javascript:void(0)" @click="removeVehicle(index)">Fjern</a>
                        <br><br>
                        <b>{{ vehicle.general.MaerkeTypeNavn }}
                        {{ vehicle.general.ModelTypeNavn }}</b>
                        <br>
                        {{ vehicle.general.VariantTypeNavn }}
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Model årgang
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        {{ vehicle.general.ModelAar }}
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Indregistreret
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        {{ vehicle.general.FoersteRegistreringDato | moment('D[.] MMMM YYYY') }}
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Motor
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        {{ vehicle.general.MotorStoerrelse }}L
                        <span v-if="vehicle.general.MotorCylinderAntal">({{ vehicle.general.MotorCylinderAntal }} cyl.)</span>
                        <br>
                        {{ vehicle.general.DrivkraftTypeNavn }}
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Effekt
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        {{ vehicle.general.MotorHestekraefter }} HK
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Max hastighed
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        <span v-if="vehicle.general.MaksimumHastighed">
                            {{ vehicle.general.MaksimumHastighed }} km/t
                        </span>
                        <span v-else>
                            -
                        </span>
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Egenvægt
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        <span v-if="vehicle.general.EgenVaegt">
                            {{ vehicle.general.EgenVaegt }} kg
                        </span>
                        <span v-else>
                            -
                        </span>
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Forbrug
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        {{ vehicle.general.MotorKmPerLiter }} km/l
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta">
                        Halvårlig afgift
                    </div>
                    <div class="line__value" v-for="vehicle in vehicles">
                        <div v-for="afgift in vehicle.dmr.Afgift.AfgiftDetaljer" v-if="afgift.AfgiftType === 'Sum'">
                            {{ afgift.Pris }}
                        </div>
                    </div>
                </div>
                <div class="line">
                    <div class="line__meta"></div>
                    <div class="line__value" v-for="vehicle in vehicles"></div>
                </div>
                <div class="line">
                    <div class="line__meta"></div>
                    <div class="line__value" v-for="vehicle in vehicles"></div>
                </div>
                <div class="line">
                    <div class="line__meta"></div>
                    <div class="line__value" v-for="vehicle in vehicles"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../styles/vars";

    .compare {
        background: $color--main--gradient;
        min-height: 100vh;

        .compare-wrapper {
            padding: 30px;
            background: #fff;

            .line {
                display: flex;
                align-items: center;
                padding: 10px;

                &__meta {
                    width: 200px;
                    margin-right: 50px;
                    padding-right: 50px;
                    text-transform: uppercase;
                }

                &__value {
                    width: 250px;
                    text-align: center;
                    padding: 0 25px;
                }
            }
        }
    }

</style>

<script>
import * as lookupService from '@/services/lookup/lookupService'

export default {
    data () {
        return {
            licenseplate: '',
            vehicles: []
        }
    },
    methods: {
        doSearch () {
            lookupService.find(this.licenseplate, {}, (response) => {
                let vehicleData = Object.assign({}, response.data[0])
                this.vehicles.push(vehicleData)
                this.licenseplate = ''
            })
        },
        removeVehicle (index) {
            this.vehicles.splice(index, 1)
        }
    }
}
</script>




// WEBPACK FOOTER //
// compare.vue?5a00c866